var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAtf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 31,
    viewBox: "0 0 72 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_9961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.97233 16.3935C11.5613 7.84775 12.1999 0.521702 10.3988 0.0303484C8.59772 -0.461006 5.03888 6.0684 2.44993 14.6142C-0.13901 23.16 -0.777674 30.486 1.02344 30.9774C2.82454 31.4687 6.38338 24.9393 8.97233 16.3935Z",
    fill: "#B3CDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4976 24.6021C44.3444 24.6021 44.4331 23.2763 44.4331 23.2763C44.4331 23.2763 44.3444 16.9521 44.4331 13.5112C44.5107 10.0702 41.0621 8.6707 41.0621 8.6707C41.0621 8.6707 35.8725 6.95549 31.5811 8.6707C27.2786 10.3859 27.4893 14.2162 27.4893 14.2162L31.9359 14.2898C31.9359 14.2898 31.5922 13.3533 32.4349 12.6483C34.0761 11.0067 36.7929 11.0909 38.6891 11.6381C40.5853 12.1853 40.5853 13.8268 40.0086 15.079C39.432 16.3313 32.4349 16.4891 30.2172 17.2678C27.9994 18.0465 26.2695 19.688 26.7574 22.7396C27.2564 25.7807 29.1415 27.8957 33.9985 27.7695C38.8554 27.6432 40.6629 25.4019 40.6629 25.4019C40.6629 25.4019 40.5853 26.6541 41.8937 27.3591C43.6236 28.2956 46.673 27.3591 46.673 27.3591V24.6232C46.6509 24.6021 46.6509 24.6021 45.4976 24.6021ZM40.1417 21.4769C40.1417 21.4769 39.8977 23.7393 37.181 24.3706C34.4642 25.002 31.3371 24.76 31.0045 22.0241C31.0045 22.0241 30.9269 19.3723 35.2072 18.9725C39.4875 18.5831 40.1417 17.8255 40.1417 17.8255V21.4769Z",
    fill: "#5F6060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.549 8.84964H50.8424V3.06213H55.1227V8.83912H59.1591V11.8907H55.1227V22.666C55.1227 22.666 54.9564 24.6127 57.5068 24.6548C58.4937 24.6548 59.148 24.6548 59.148 24.6548V27.759C59.148 27.759 56.2649 28.2957 53.3485 27.5065C50.4321 26.7278 50.6761 22.203 50.6761 22.203L50.7537 11.8907H47.549V8.84964Z",
    fill: "#5F6060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6058 8.76545V6.50305C63.6058 6.50305 63.2953 2.36762 67.1098 1.73625C68.7953 1.42057 72 1.73625 72 1.73625V5.17719C72 5.17719 70.4365 4.70366 69.5272 4.85098C68.6179 5.00882 67.7974 5.32451 67.7974 6.49253C67.7974 7.66056 67.7974 8.75492 67.7974 8.75492H71.501V11.6487H68.13V27.7485H63.5947V11.9644H60.39V8.76545H63.6058Z",
    fill: "#5F6060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7656 30.7838C22.5444 30.224 21.5952 22.9282 18.6455 14.4882C15.6958 6.04825 11.8626 -0.339882 10.0838 0.219938C8.30499 0.779758 9.25417 8.07553 12.2039 16.5155C15.1535 24.9555 18.9868 31.3436 20.7656 30.7838Z",
    fill: "#1A6ED3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_9961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAtf);
export default __webpack_public_path__ + "static/media/logo-atf.a55a01ae5c2f75c0feddbbd4efb4192b.svg";
export { ForwardRef as ReactComponent };